











import Vue from "vue";
export default Vue.extend({
  name: "tab-pane",
  props: ["label", "id", "showActionRequiredIndicator"] as any[],
  inject: ["addTab", "removeTab"] as any[],
  data() {
    return {
      active: false,
    };
  },
  mounted() {
    this.addTab(this);
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.removeTab(this);
  },
});
